import React, { useEffect, useCallback, useState, useRef, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { Dropdown } from 'ui_kit_qmd'
import { Calendar } from 'react-calendar'
import moment from 'moment-timezone'
import { styles, text } from './Constants'
import './VisitInformation.scss'
import { ProviderTile } from './components/provider-tile/ProviderTile'
import { TimeTile } from '../time-tile/TimeTile'
import lockIcon from '../../../../images/common/lock-2.png'
import clockIcon from '../../../../images/common/clock.png'
import 'react-calendar/dist/Calendar.css'
import calendarIcon from '../../../../images/common/calendar.png'
import { getStateByAbbreviation } from '../../../../utils/common'
import { getTimeOptionsListHours } from '../../../../utils/commonCalendar'
import { DATE_TIME_ISO_FORMAT, DEFAULT_DATE_FORMAT_WITHOUT_TIME } from '../../../../utils/dateUtils'
import { RESCHEDULE_VISIT_PAGE_PATH } from '../../../../utils/constants'
import { VisitMethodOptions } from './VisitMethods'
import { useProviderAvailability } from '../../hooks/useProviderAvailability'

export const VisitInformation = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  provider,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  defaultDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  serviceVisitNames,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  methods,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  states,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setVisitOptions,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  dateError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  timeError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  stateError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  methodError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitError,
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  zoneAbbr,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  timeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  show,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  zoneAbbrString,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  patientState,
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  useDefaultTime: _useDefaultTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  providerServiceVisitTypes,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  defaultMethod,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isInPerson,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isMethodsLoading,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  providerId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  patientId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTypeId,
}) => {
  const { pathname, state: locationState } = useLocation()
  const isReschedulePage = pathname === RESCHEDULE_VISIT_PAGE_PATH

  const serviceVisitStyleHeight = useRef({
    height: serviceVisitNames.length === 1 || serviceVisitNames.length === 2 ? 'max-content' : 153,
  })
  const stateStyleHeight = useRef({
    height: 153,
  })
  const [date, setDate] = useState(defaultDateTime?.displayDate || '')
  const [time, setTime] = useState('')
  const [timeFilter, setTimeFilter] = useState(`All day${zoneAbbrString ? ` (${zoneAbbrString})` : ''}`)
  const [serviceVisitName, setServiceVisitName] = useState('')
  const [state, setState] = useState('')
  const [method, setMethod] = useState(isReschedulePage ? locationState.visitMethod : (defaultMethod ?? ''))

  const timeFilterRef = useRef(null)

  React.useEffect(() => {
    if (isInPerson) setMethod(VisitMethodOptions.IN_PERSON)
    else setMethod('')
  }, [isInPerson])

  useEffect(() => {
    if (!isInPerson && method && !methods.includes(method)) {
      setMethod('')
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setUpVisit('method', '')
    }
  }, [methods, isInPerson])

  const [providerName, setProviderName] = useState('--')
  const [titles, setTitles] = useState('--')
  const [statesKey, setStatesKey] = useState(1)
  const [serviceVisitNameKey, setServiceVisitNameKey] = useState(1)

  const {
    timeSlots,
    isLoading: isSlotsLoading,
    isError: isSlotsError,
  } = useProviderAvailability({
    providerId,
    date,
    timeZone,
    visitTypeId,
    patientId,
  })

  const timeFilterOptions = useMemo(
    () => getTimeOptionsListHours(zoneAbbrString, date, timeZone),
    [zoneAbbrString, date, timeZone],
  )

  const filteredTimeSlots = useMemo(() => {
    if (!timeFilter || timeFilter.toLowerCase().includes('all day')) return timeSlots
    const rangeStr = (timeFilter.split('(')[0] ?? timeFilter).trim()
    const parts = rangeStr.split('-').map((t: string) => t.trim())
    const toMinutes = (t: string, fmt: string) => {
      const parsed = moment(t, fmt)
      return parsed.isValid() ? parsed.hours() * 60 + parsed.minutes() : null
    }
    const start = toMinutes(parts[0] ?? '', 'h:mma')
    const end = toMinutes(parts[1] ?? '', 'h:mma')
    if (start === null || end === null) return timeSlots
    const endExclusive = end === 0 ? 24 * 60 : end
    return timeSlots.filter((slot: string) => {
      const mins = toMinutes(slot, 'HH:mm')
      return mins !== null && mins >= start && mins < endExclusive
    })
  }, [timeSlots, timeFilter])

  const timeSlotsMessage = useMemo(() => {
    if (!serviceVisitName) return 'Select a visit type to see available times'
    if (!state) return 'Select a booking state to see available times'
    if (!date) return 'Select a date to see available times'
    return null
  }, [serviceVisitName, state, date])

  // Function to set up visit options
  const setUpVisit = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (type, value, extra) => {
      const visitOptions = {
        updateType: type,
        state,
        method,
        serviceVisitName,
        providerName,
      }
      switch (type) {
        case 'state':
          visitOptions.state = value
          break
        case 'method':
          visitOptions.method = value
          break
        case 'serviceVisitName':
          visitOptions.serviceVisitName = value
          break
        case 'date':
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          if (extra) visitOptions.time = extra === 'time' ? true : undefined
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          visitOptions.date = value
          break
        default:
      }
      setVisitOptions(visitOptions)
    },
    [setVisitOptions, state, method, serviceVisitName, providerName],
  )

  useEffect(() => {
    if (isReschedulePage && providerServiceVisitTypes?.length) {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setUpVisit('serviceVisitName', locationState.visitType)
      setTimeout(() => {
        setServiceVisitName(locationState.visitType)
      })
    }
  }, [isReschedulePage, providerServiceVisitTypes])

  // Effect to handle date selection
  useEffect(() => {
    if (show && date && time) {
      const newSelection = moment(
        `${moment(date, 'dddd MMM D YYYY').format(DEFAULT_DATE_FORMAT_WITHOUT_TIME)} ${time}`,
        'YYYY-MM-DD HH:mm',
      ).tz(timeZone, true)
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      if (newSelection) setUpVisit('date', newSelection.format(DATE_TIME_ISO_FORMAT))
    }
  }, [show, date, time, timeZone])

  // Effect to handle service visit names
  useEffect(() => {
    if (serviceVisitNames.length >= 1) {
      serviceVisitStyleHeight.current = {
        height: serviceVisitNames.length === 1 || serviceVisitName?.length === 2 ? 'max-content' : 153,
      }
      if (serviceVisitNames.length === 1) {
        setServiceVisitName(serviceVisitNames[0] || '')
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        setUpVisit('serviceVisitName', serviceVisitNames[0])
        setServiceVisitNameKey(Math.random())
      } else {
        setServiceVisitName('')
      }
    }
  }, [serviceVisitNames])

  // Effect to handle states
  useEffect(() => {
    // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
    stateStyleHeight.current =
      !states || states.length === 1 || states.length === 0 || states.length === 2 ?
        { height: 'max-content' }
      : { height: 153 }
    if (states) {
      if (states.length === 1) {
        setState(states[0])
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        setUpVisit('state', states[0])
        setStatesKey(Math.random())
      } else if (isReschedulePage && locationState?.visitStateCode) {
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        const currentStateValue = states.find((stateItem) => stateItem.split(' ')[1] === locationState?.visitStateCode)
        setState(currentStateValue)
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        setUpVisit('state', currentStateValue)
        setStatesKey(Math.random())
      } else {
        setState('')
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        setUpVisit('state', '')
      }
    } else {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setUpVisit('state', '')
    }
  }, [states])

  const onSetState = useCallback(
    (value: string) => {
      setState(value)
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setUpVisit('state', value)
    },
    [setUpVisit],
  )

  const onSetMethod = useCallback(
    (value: string) => {
      setMethod(value)
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setUpVisit('method', value)
    },
    [setUpVisit],
  )

  const onSetServiceVisitName = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      if (value === serviceVisitName) return
      setServiceVisitName(value)
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setUpVisit('serviceVisitName', value)
    },
    [setUpVisit],
  )

  const onSetDate = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setDate(moment(value).format('dddd MMM D YYYY'))
      setTime('')
      setTimeFilter(`All day${zoneAbbrString ? ` (${zoneAbbrString})` : ''}`)
      setUpVisit('date', moment(value).startOf('day').tz(timeZone, true).format(DATE_TIME_ISO_FORMAT), 'date')
    },
    [setUpVisit, timeZone, zoneAbbrString],
  )

  const onSetTimeFilter = useCallback((value: string) => {
    setTimeFilter(value)
  }, [])

  const onSetTime = useCallback(
    (value: string) => {
      const newSelection = moment(
        `${moment(date, 'dddd MMM D YYYY').format(DEFAULT_DATE_FORMAT_WITHOUT_TIME)} ${value}`,
        'YYYY-MM-DD HH:mm',
      ).tz(timeZone, true)
      setTime(value)
      setUpVisit('date', newSelection.format(DATE_TIME_ISO_FORMAT), 'time')
    },
    [setUpVisit, date, timeZone],
  )

  useEffect(() => {
    const { Prefix, FirstName, LastName, Suffix } = { ...provider }
    setProviderName(
      provider.FirstName ?
        `${Prefix || ''} ${FirstName} ${LastName} ${Suffix || ''}`.trim()
      : provider.providerName || '--',
    )
    if (provider?.ProfessionalTitles?.length) {
      setTitles(() => {
        let titleString = ''
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        provider.ProfessionalTitles?.map((pro, index) => {
          if (index === provider.ProfessionalTitles.length - 1) {
            titleString += pro
          } else {
            titleString += `${pro}; `
          }
        })
        return titleString
      })
    }
  }, [provider])

  if (!show) {
    return null
  }

  const methodsWithInPersonOverride = isInPerson ? [VisitMethodOptions.IN_PERSON] : methods

  return (
    <div className='new-visit-information-container'>
      <label htmlFor='null' className='new-visit-information-title'>
        {text.VISIT_INFORMATION}
      </label>
      {/*
       // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered */}
      <ProviderTile imageUrl={provider.ImageUrl} providerName={providerName} providerTitles={titles} />

      {/* Service Visit + Method row */}
      <div className='new-visit-information-input-row'>
        <Dropdown
          key={serviceVisitNameKey}
          isAutoRowHeight
          isDisabled={isReschedulePage}
          customIcon={!isReschedulePage ? null : lockIcon}
          customIconStyles={!isReschedulePage ? null : styles.CALENDAR_IMAGE_STYLE}
          dropdownMainContainerAdditionalStyle={{
            ...styles.DROP_DOWN_MAIN_CONTAINER_STYLE,
            ...(date && !serviceVisitName ? { border: '1px solid #e8a62e', borderRadius: 4 } : {}),
          }}
          containerStyle={styles.DROP_DOWN_CONTAINER_STYLE}
          options={serviceVisitNames}
          dropdownContainerStyle={{ ...styles.DROP_DOWN_STYLE, ...serviceVisitStyleHeight.current }}
          value={serviceVisitName}
          setValue={onSetServiceVisitName}
          dropDownListItemStyle={styles.VISIT_TYPE_ITEM_STYLE}
          dropId={text.VISIT_TYPE}
          label={text.VISIT_TYPE}
          localError={visitError}
          isWithGeneratedOnTheFlyOptions
        />
        <Dropdown
          key={JSON.stringify(methodsWithInPersonOverride)}
          isAutoRowHeight
          isDisabled={!!isInPerson || isMethodsLoading}
          dropdownMainContainerAdditionalStyle={styles.DROP_DOWN_MAIN_CONTAINER_STYLE}
          containerStyle={styles.DROP_DOWN_CONTAINER_STYLE}
          options={methodsWithInPersonOverride}
          dropdownContainerStyle={styles.METHOD_DROP_DOWN_STYLE}
          value={method}
          localError={methodError}
          setValue={onSetMethod}
          dropId={text.VISIT_METHOD}
          label={text.VISIT_METHOD}
        />
      </div>

      {/* State row */}
      <div className='new-visit-information-input-row'>
        <Dropdown
          key={statesKey}
          isWithGeneratedOnTheFlyOptions
          isAutoRowHeight
          isDisabled={!states}
          options={states || []}
          dropdownMainContainerAdditionalStyle={{
            ...styles.DROP_DOWN_MAIN_CONTAINER_STYLE,
            ...(date && !state ? { border: '1px solid #e8a62e', borderRadius: 4 } : {}),
          }}
          containerStyle={styles.DROP_DOWN_CONTAINER_STYLE}
          dropdownContainerStyle={{ ...styles.STATES_DROP_DOWN_STYLE, ...stateStyleHeight.current }}
          value={state}
          setValue={onSetState}
          dropId={text.BOOKING_STATE}
          label={text.BOOKING_STATE}
          localError={stateError}
          customIcon={states ? null : lockIcon}
          customIconStyles={states ? null : styles.CALENDAR_IMAGE_STYLE}
          emptyMsg={`${text.STATE_EMPTY_MSG} ${getStateByAbbreviation(patientState || '')}`}
        />
      </div>

      {/* Date + Time filter row */}
      <div className='new-visit-information-input-row'>
        <Dropdown
          isDateCase
          showAbove
          isStateDropdown
          dropdownMainContainerAdditionalStyle={styles.DROP_DOWN_MAIN_CONTAINER_STYLE}
          containerStyle={styles.DROP_DOWN_CONTAINER_STYLE}
          isCalendarOptions
          dropdownContainerStyle={styles.CALENDAR_DROP_DOWN_STYLE}
          value={date}
          calendarValue={date}
          setCalendarValue={onSetDate}
          dropId={text.DATE}
          label={text.DATE}
          minCalendarDate={new Date(moment()?.parseZone()?.tz(timeZone, false)?.format('YYYY-MM-DD HH:mm'))}
          isShowStar
          customIcon={calendarIcon}
          localError={dateError}
          customIconStyles={styles.CALENDAR_IMAGE_STYLE}
          Calendar={Calendar}
          timeZone={timeZone}
        />
        <Dropdown
          ref={timeFilterRef}
          isDateCase
          isStateDropdown
          dropdownMainContainerAdditionalStyle={styles.DROP_DOWN_MAIN_CONTAINER_STYLE}
          containerStyle={styles.DROP_DOWN_CONTAINER_STYLE}
          options={timeFilterOptions}
          dropdownContainerStyle={styles.TIME_DROP_DOWN_STYLE}
          value={timeFilter}
          setValue={onSetTimeFilter}
          dropId={text.TIME}
          label={text.TIME}
          customIcon={clockIcon}
          customIconStyles={styles.CALENDAR_IMAGE_STYLE}
        />
      </div>

      {/* Time slots */}
      <div className='new-visit-time-slots-container'>
        <label className='new-visit-time-slots-label'>{text.TIME} *</label>
        {timeSlotsMessage ?
          <p className='new-visit-time-slots-message'>{timeSlotsMessage}</p>
        : isSlotsLoading ?
          <p className='new-visit-time-slots-message'>Loading available times...</p>
        : isSlotsError ?
          <p className='new-visit-time-slots-message'>Could not load availability</p>
        : filteredTimeSlots.length === 0 ?
          <p className='new-visit-time-slots-message'>
            {timeSlots.length === 0 ? 'No available times for this date' : 'No available times in this time range'}
          </p>
        : <div className='new-visit-time-slots-grid'>
            {filteredTimeSlots.map((slot: string) => (
              <TimeTile key={slot} timeValue={slot} setIsSelected={onSetTime} isSelected={time === slot} />
            ))}
          </div>
        }
        {timeError ?
          <span className='new-visit-time-error'>{timeError}</span>
        : null}
      </div>
    </div>
  )
}
